module.exports = __webpack_public_path__ + "static/media/Milan_WelcomeKit_Spanish_digital_111119.135f2cb8.pdf";